import { render, staticRenderFns } from "./WBonosItem.vue?vue&type=template&id=296ec17a&scoped=true&"
import script from "./WBonosItem.vue?vue&type=script&lang=js&"
export * from "./WBonosItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296ec17a",
  null
  
)

export default component.exports